import React from 'react';
import { FaCheckCircle, FaBullseye, FaEye, FaHeart } from 'react-icons/fa';
import ContactCTA from '../components/ContactCTA';
import '../styles/About.css';

const About = () => {
  return (
    <div className="about-page">
      <section className="page-hero" style={{backgroundImage: 'url(/images/about-bg.png)'}}>
        <div className="page-hero-background">
          <img
            src="/images/about-bg.png"
            alt="Global consulting background"
            className="page-hero-bg-image"
          />
        </div>
        <div className="container">
          <h1>About JWCS</h1>
          <p>Bridging Talent with Global Excellence</p>
        </div>
      </section>

      <section className="about-intro">
        <div className="container">
          <div className="about-intro-grid">
            <div className="about-intro-content">
              <h2>About JOY WORLDWIDE CONSULTANCY SERVICES (JWCS)</h2>
              <p>
                At JOY WORLDWIDE CONSULTANCY SERVICES (JWCS), we believe that world-class business
                begins with world-class talent. In an increasingly complex global marketplace, the
                gap between finding exceptional candidates and managing cross-border staffing logistics
                is often difficult to navigate. We exist to be that vital bridge.
              </p>
              <p>
                Founded on the principle that Human Resources should be a source of strength—not
                stress—we partner with organizations looking to scale, optimize, and enrich their
                workforce across the globe. Our mission is to transform complex HR challenges into
                clear, compliant, and successful talent strategies, allowing you to experience the
                Joy of Global Success.
              </p>
            </div>
            <div className="about-intro-image">
              <img
                src="/images/about-bg-2.jpeg"
                alt="JWCS Healthcare Team"
                className="about-team-img"
              />
            </div>
          </div>

          <div className="about-philosophy-wrapper">
            <div className="about-philosophy">
              <h3>Our Core Philosophy: The JOY Difference</h3>
              <ul className="about-features">
                <li><FaCheckCircle /> <strong>Jurisdictional Expertise:</strong> Providing precise,
                  localized compliance and HR knowledge worldwide.</li>
                <li><FaCheckCircle /> <strong>Optimized Strategy:</strong> Crafting strategic solutions
                  that maximize performance and minimize risk.</li>
                <li><FaCheckCircle /> <strong>Year-Round Partnership:</strong> Offering continuous
                  support, from initial staffing needs to long-term culture building.</li>
              </ul>
              <p>
                We champion a positive, people-first approach, ensuring that your organization attracts,
                retains, and engages the talent necessary to thrive anywhere in the world.
              </p>
            </div>
          </div>
        </div>
      </section>

      <section className="mission-vision">
        <div className="container">
          <div className="section-header">
            <h2>What We Deliver</h2>
            <p>As your dedicated global HR consultancy, we offer comprehensive services designed to handle the full talent lifecycle:</p>
          </div>

          <div className="mv-grid">
            <div className="mv-card">
              <div className="mv-card-image">
                <img
                  src="https://images.unsplash.com/photo-1600880292089-90a7e086ee0c?ixlib=rb-4.0.3&auto=format&fit=crop&w=500&q=80"
                  alt="Global talent acquisition team"
                  className="mv-card-img"
                />
              </div>
              <h3>1. Global Staffing & Talent Acquisition</h3>
              <p>
                <strong>Connecting Excellence:</strong> We specialize in sourcing, vetting, and placing elite
                candidates across continents, ensuring a perfect cultural and operational fit for your
                organization's most critical roles.
              </p>
              <p>
                <strong>Recruitment Efficiency:</strong> Streamlining global hiring processes to reduce time-to-hire while
                maintaining the highest quality standards.
              </p>
            </div>

            <div className="mv-card">
              <div className="mv-card-image">
                <img
                  src="https://images.unsplash.com/photo-1552664730-d307ca884978?ixlib=rb-4.0.3&auto=format&fit=crop&w=500&q=80"
                  alt="HR consulting strategy meeting"
                  className="mv-card-img"
                />
              </div>
              <h3>2. Strategic HR Consulting</h3>
              <p>
                <strong>Organizational Design:</strong> Developing optimized structures for scaling teams, managing remote
                employees, and establishing efficient global operations.
              </p>
              <p>
                <strong>Performance Management:</strong> Implementing systems that drive accountability, foster continuous
                improvement, and align employee performance with global business objectives.
              </p>
            </div>

            <div className="mv-card">
              <div className="mv-card-image">
                <img
                  src="https://images.unsplash.com/photo-1436491865332-7a61a109cc05?ixlib=rb-4.0.3&auto=format&fit=crop&w=500&q=80"
                  alt="International travel and mobility"
                  className="mv-card-img"
                />
              </div>
              <h3>3. Compliance and Mobility</h3>
              <p>
                <strong>Worldwide Compliance:</strong> Navigating the complexities of international labor laws, payroll,
                and benefits to ensure your global footprint is secure and compliant.
              </p>
              <p>
                <strong>Cross-Border Mobility:</strong> Facilitating seamless transitions for employees moving across borders,
                handling visas, documentation, and localized onboarding.
              </p>
            </div>
          </div>
        </div>
      </section>

<ContactCTA />
    </div>
  );
};

export default About;
